import React, { Component } from 'react';
import { Link } from 'react-router';
import withNotify from '../common/withNotify';
import withLoader from '../common/withLoader';
import withGoBack from '../common/withGoBack';
import withTableName from '../common/withTableName';
import withCaseFilter from '../common/withCaseFilter';
import withSearchFilter from '../common/withSearchFilter';
import Bugsnag from '../helpers/bugsnag';
import { getTeamData, getTerritoryData, storeLastVisitedRoute } from '../common/globals';
import withUser from '../common/withUser.js';
import withSalesYTD from '../common/withSalesYTD.js';
import CalendarOutline1 from '../assets/images/icon-calendar-blank-outline-1.png';
import CalendarOutline7 from '../assets/images/icon-calendar-blank-outline-7.png';
import CalendarOutline14 from '../assets/images/icon-calendar-blank-outline-14.png';

class CalenderSearchSection extends Component {
  _onClickFilter = () => {
    try {
      const {
        goBack, setGoBack, setTableName, table, setCaseFilter, setSearchFilter
      } = this.props;
      setCaseFilter({});
      setTableName(table);
      setSearchFilter({});
      goBack.push(window.location.pathname);
      storeLastVisitedRoute('filter');
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSevenDayData = () => {
    try {
      const todayDate = new Date();
      const futureDate = new Date();
      futureDate.setDate(todayDate.getDate() + 7);

      this._onFilter({
        selectedStartDate: new Date(todayDate),
        selectedEndDate: new Date(futureDate)
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onFourteenDayData = () => {
    try {
      const todayDate = new Date();
      const futureDate = new Date();
      futureDate.setDate(todayDate.getDate() + 14);

      this._onFilter({
        selectedStartDate: new Date(todayDate),
        selectedEndDate: new Date(futureDate)
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onFilter = (data) => {
    try {
      const { onFilter, previousData } = this.props;
      onFilter(Object.assign(previousData, data));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      onToday, selectedTeam, screenWidth, user, salesYTD
    } = this.props;
    const { isSalesMetrics } = getTerritoryData(user);
    const { salesAccess } = getTeamData(user);

    return (
      <section className="top-filter-section">
        <div className="container">
          <div className="row">
            <div className={`${screenWidth < 800 ? 'col-6 headerLeftIcon' : 'col-8 headerLeftIcon'}`}>
              <div style={{
                display: 'flex',
                gap: '15px'
              }}
              >
                <p
                  className={`${screenWidth < 800 ? 'text-overflow-selectedTeam' : ''} ${screenWidth < 800 && salesAccess && isSalesMetrics ? 'textOverflowSelectedTeam' : 'textOverflowSelectedTeam2'}`}
                >
                  {selectedTeam}
                </p>
                <div style={{
                  whiteSpace: 'nowrap'
                }}
                >
                  {salesAccess && isSalesMetrics && `YTD: ${salesYTD ? `${Math.round(salesYTD)}%` : '-'}`}
                </div>
              </div>
            </div>
            <div className="col text-end">
              <div className="action headerRightIcon">
                {/* <Link className="link cursor-pointer" onClick={() => onToday()}>Today</Link> */}

                <Link onClick={() => onToday()} className="day link cursor-pointer">
                  <img width="28px" src={CalendarOutline1} alt="today" />
                </Link>
                <Link onClick={() => this._onSevenDayData()} className="day link cursor-pointer">
                  <img width="28px" src={CalendarOutline7} alt="seven days" />
                </Link>
                <Link onClick={() => this._onFourteenDayData()} className="day link cursor-pointer">
                  <img width="28px" src={CalendarOutline14} alt="fourteen days" />
                </Link>

                <Link onClick={this._onClickFilter} className="daySearch link" to="/manage-cases/filter">
                  <i className="fas fa-search" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default withSearchFilter(
  withCaseFilter(
    withTableName(
      withGoBack(
        withNotify(
          withLoader(
            withUser(
              withSalesYTD(
                CalenderSearchSection
              )
            )
          )
        )
      )
    )
  )
);
